class CuratedDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()

    this.originalTopPosition = this.parentNode.getBoundingClientRect().top + window.scrollY + this.offsetHeight

    this.scrollFunction()
  }

  setupListeners () {
    this.listeners.add(window, 'scroll', this.scrollFunction.bind(this))
  }

  scrollFunction () {
    if (window.scrollY > this.originalTopPosition) {
      this.style.zIndex = '-1'
    } else {
      this.style.removeProperty('z-index')
    }
  }
}

if (!customElements.get('curated-description')) {
  customElements.define('curated-description', CuratedDescription)
}
